/**
 * <p-ifb-slider data-cols="2"> — Punkte-Navigation der Section „Icon Feature Bar" (1:1 wie Hyper-Inline-Script).
 * Mobile (< 750 px) scrollt der Track per nativem Scroll-Snap; ein Punkt = data-cols Items.
 * Klick auf Punkt → weich zur Seite scrollen; beim Wischen wird der aktive Punkt nachgeführt.
 */
if (!customElements.get('p-ifb-slider')) {
  class PIfbSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ifb-track]');
      this.dots = [...this.querySelectorAll('[data-ifb-dot]')];
      if (!this.track || this.dots.length === 0) return;

      this.cols = Number(this.dataset.cols) || 1;
      this.page = 0;
      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', () => {
          this.page = i;
          this.scrollToPage(i);
          this.setActive(i);
        })
      );
      this.onScroll = () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.sync(), 80);
      };
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      clearTimeout(this.scrollTimer);
    }

    get itemWidth() {
      return this.track.scrollWidth / this.track.children.length;
    }

    scrollToPage(page) {
      this.track.scrollTo({ left: page * this.cols * this.itemWidth, behavior: 'smooth' });
    }

    sync() {
      if (window.innerWidth >= 750) return;
      const page = Math.min(Math.round(this.track.scrollLeft / (this.cols * this.itemWidth)), this.dots.length - 1);
      if (page === this.page) return;
      this.page = page;
      this.setActive(page);
    }

    setActive(page) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === page);
        if (i === page) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
  }

  customElements.define('p-ifb-slider', PIfbSlider);
}
